<template>
  <Header :show_back="true" />
  <div class="w-content-standard mx-auto mb-8 pt-10">
    <!-- Search Box -->
    <input
        v-model="search_query"
        type="text"
        placeholder="Search staff members..."
        class="search-box mb-4 p-2 border rounded w-full"
    />

    <!-- Loading Indicator -->
    <div v-if="is_loading" class="text-center">Loading staff members...</div>

    <!-- Error Message -->
    <div v-if="error_message" class="text-center text-red-600">Error loading staff members. Please try again later.</div>

    <!-- Filtered Staff List -->
    <div
        v-for="staff_member in filtered_staff"
        :key="staff_member.id"
        class="clickable-box mb-2"
        @click="handle_click(staff_member.id, staff_member.name)"
    >
      <div class="pl-4">
        <div class="font-bold mr-4">{{ staff_member.name }}</div>
        <div class="text-sm text-gray-600">{{ staff_member.email || 'No Email Provided' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, computed } from "vue";
import { useRouter } from 'vue-router';
import { useAppStore } from '@/store/app';
import axios from "axios";
import Header from "./Header.vue";

export default {
  name: "ChooseUserConfigurableForm",
  components: { Header },
  props: ["form_id"],
  setup(props) {
    const app_store = useAppStore();
    const router = useRouter();
    const staff = ref([]);
    const is_loading = ref(true);
    const error_message = ref(null);
    const search_query = ref("");

    onMounted(async () => {
      try {
        const response = await axios.get(`/api/staff`);
        staff.value = response.data;
      } catch (err) {
        console.error("Error fetching staff data:", err);
        error_message.value = "Failed to load staff members.";
      } finally {
        is_loading.value = false;
      }
    });

    // Computed property for filtering staff based on search_query
    const filtered_staff = computed(() => {
      if (!search_query.value) return staff.value;
      return staff.value.filter(member =>
          member.name.toLowerCase().includes(search_query.value.toLowerCase()) ||
          member.email?.toLowerCase().includes(search_query.value.toLowerCase())
      );
    });

    const handle_click = (id,name) => {
      app_store.chosen_user_id = id;
      app_store.chosen_user_name = name;
      console.log(`Clicked item with id and name:`,id,name);
      console.log(`Clicked item with form_id: ${props.form_id}`);
      // Navigate to /ConfigurableForm/:form_id using the prop
      //router.push({ path: `/ConfigurableForm/${props.form_id}` });
      router.push({
        path: `/ConfigurableForm/${props.form_id}`,
        query: { user_id: id, user_name: name }
      });
    }

    return {
      handle_click,
      staff,
      is_loading,
      error_message,
      search_query,
      filtered_staff
    };
  },
};
</script>

<style scoped>
.search-box {
  border: 1px solid #ccc;
  padding: 8px;
}
.clickable-box {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
  cursor: pointer;
  border-radius: 8px;
  transition: transform 0.2s;
}
.clickable-box:hover {
  transform: scale(1.05);
  background-color: #f9f9f9;
}
</style>